import { useEffect, useState } from "react";
import {
    Menu,
    Search,
    ShoppingBag,
    Heart,
    User,
    Leaf
} from "lucide-react";

import MobileMenu from "./MobileMenu";

export default function Navbar(){

    const [scrolled,setScrolled]=useState(false);
    const [open,setOpen]=useState(false);

    useEffect(()=>{

        const handleScroll=()=>{

            setScrolled(window.scrollY>40);

        }

        window.addEventListener("scroll",handleScroll);

        return ()=>window.removeEventListener("scroll",handleScroll);

    },[]);

    return(

<header
className={`sticky top-0 z-50 transition-all duration-300

${scrolled
?"bg-white/90 backdrop-blur-xl shadow-sm"
:"bg-transparent"}

`}
>

<div className="max-w-7xl mx-auto">

<div className="flex items-center justify-between h-20 px-6">

{/* Logo */}

<div className="flex items-center gap-2">

<div className="w-10 h-10 rounded-full bg-[#6B8E5F]/10 flex items-center justify-center">

<Leaf className="text-[#6B8E5F]" size={20}/>

</div>

<div>

<h1 className="font-semibold text-xl">
Cultivate
</h1>

<p className="text-xs text-gray-500">
& Co.
</p>

</div>

</div>

{/* Desktop Menu */}

<nav className="hidden lg:flex items-center gap-10">

<a href="/" className="hover:text-[#6B8E5F] transition">
Shop
</a>

<a href="/" className="hover:text-[#6B8E5F] transition">
Collections
</a>

<a href="/" className="hover:text-[#6B8E5F] transition">
Journal
</a>

<a href="/" className="hover:text-[#6B8E5F] transition">
About
</a>

</nav>

{/* Icons */}

<div className="hidden lg:flex items-center gap-5">

<Search className="cursor-pointer"/>

<Heart className="cursor-pointer"/>

<ShoppingBag className="cursor-pointer"/>

<User className="cursor-pointer"/>

</div>

{/* Mobile */}

<button
className="lg:hidden"
onClick={()=>setOpen(true)}
>

<Menu/>

</button>

</div>

</div>

<MobileMenu
open={open}
setOpen={setOpen}
/>

</header>

    )

}